import { render, staticRenderFns } from "./AegCaseSendingInsurance.vue?vue&type=template&id=0218704c"
import script from "./AegCaseSendingInsurance.vue?vue&type=script&lang=js"
export * from "./AegCaseSendingInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports